export const colors = {
  black: "#222222",
  blue: "#012842",
  grey100: "#F2F2F2",
  grey400: "#DFDEDA",
  white: "#FFFFFF",
};
